import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { api } from '@/lib/api';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { toast } from 'sonner';
import { Mail } from 'lucide-react';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const submit = async (e) => {
    e.preventDefault(); setLoading(true);
    try {
      await api.post('/auth/forgot-password', { email });
      setSent(true);
      toast.success('Si el email existe, recibirás un enlace.');
    } catch { toast.error('Error'); } finally { setLoading(false); }
  };
  return (
    <div className="min-h-screen bg-[#F8FAFC] flex items-center justify-center p-6">
      <Card className="w-full max-w-md">
        <CardHeader>
          <CardTitle className="font-display text-3xl font-extrabold">Recuperar contraseña</CardTitle>
          <p className="text-sm text-slate-500">Te enviaremos un enlace seguro.</p>
        </CardHeader>
        <CardContent>
          {sent ? (
            <div className="space-y-4">
              <div className="rounded-2xl bg-emerald-50 text-emerald-800 p-4 flex gap-3">
                <Mail className="w-5 h-5 shrink-0 mt-0.5"/>
                <div className="text-sm">Si <b>{email}</b> está registrado, te enviamos un enlace válido por 1 hora.</div>
              </div>
              <Link to="/login" className="text-blue-600 font-semibold text-sm">← Volver al login</Link>
            </div>
          ) : (
            <form onSubmit={submit} className="space-y-4">
              <div>
                <Label>Email</Label>
                <Input data-testid="forgot-email" type="email" value={email} onChange={(e)=>setEmail(e.target.value)} required/>
              </div>
              <Button data-testid="forgot-submit" type="submit" disabled={loading} className="w-full rounded-full bg-blue-600 hover:bg-blue-700 border-b-4 border-blue-800 btn-tactile h-11 font-bold">
                {loading ? 'Enviando…' : 'Enviar enlace'}
              </Button>
              <div className="text-sm text-slate-500 text-center">
                <Link to="/login" className="text-blue-600 font-semibold">← Volver</Link>
              </div>
            </form>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
